import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import BoxWithIcon from '../atoms/ComponentBox/BoxWithIcon';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectPermissions } from '../redux/permissionsSlice';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const UtilitiesCard = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const permissions = useSelector(selectPermissions);

    const hasModulePermission = (moduleName) => {
        const modulePermission = permissions.find(
            permission => permission.ModuleName === moduleName
        );

        if (!modulePermission) return false;

        return (
            modulePermission.AddRec === '1' ||
            modulePermission.EditRec === '1' ||
            modulePermission.DeleteRec === '1' ||
            modulePermission.ViewRec === '1'
        );
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container sx={{
                width: '100%',
                maxWidth: '100%'
            }}>
                <Grid item xs={12}>
                    <Grid container spacing={1} sx={{ marginTop: '10px' }}>
                        {hasModulePermission("Directory") && (
                            <BoxWithIcon
                                totalCount={10}
                                activeCount={10}
                                inactiveCount={10}
                                link={{ pathname: '/directory' }}
                                permissions={permissions}
                                title='Directory'
                            />
                        )}
                        {hasModulePermission("Notice Board") && (
                            <BoxWithIcon
                                totalCount={10}
                                activeCount={10}
                                inactiveCount={10}
                                link={{ pathname: '/info-board-table' }}
                                permissions={permissions}
                                title='Notice Board'
                            />
                        )}
                        {hasModulePermission("BroadCast Master") && (
                            <BoxWithIcon
                                totalCount={10}
                                activeCount={10}
                                inactiveCount={10}
                                link={{ pathname: '/broadcasttable' }}
                                permissions={permissions}
                                title='BroadCast Master'
                            />
                        )}
                        {hasModulePermission("BroadCast Master") && (
                            <BoxWithIcon
                                totalCount={10}
                                activeCount={10}
                                inactiveCount={10}
                                link={{ pathname: '/broadcastingtable' }}
                                permissions={permissions}
                                title='BroadCasting'
                            />
                        )}
                        {hasModulePermission("Send Email") && (
                            <BoxWithIcon
                                totalCount={10}
                                activeCount={10}
                                inactiveCount={10}
                                link={{ pathname: '/send-email' }}
                                permissions={permissions}
                                title="Send Email"
                            />
                        )}
                        {hasModulePermission("Send Email") && (
                            <BoxWithIcon
                                totalCount={10}
                                activeCount={10}
                                inactiveCount={10}
                                link={{ pathname: '/emaillog' }}
                                permissions={permissions}
                                title="Email Log"
                            />
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};

export default UtilitiesCard;